import { render, staticRenderFns } from "./activitiesDetail2023hd.vue?vue&type=template&id=d7df4bf6&scoped=true"
import script from "./activitiesDetail2023hd.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2023hd.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2023hd.vue?vue&type=style&index=0&id=d7df4bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7df4bf6",
  null
  
)

export default component.exports